<template>
  <div>
    <h1 class="headline-secondary text--center spacing">
      {{ this.$i18n.t('DOWNLOAD_LINKS.HEADER1') }}<span class="text--blue text--script">{{ this.$i18n.t('DOWNLOAD_LINKS.HEADER2') }}</span>
    </h1>
    <p>
      {{ this.$i18n.t('DOWNLOAD_LINKS.P1A') }}
      <strong>{{ this.$i18n.t('DOWNLOAD_LINKS.P1B') }}</strong>
    </p>
    <p>
      {{ this.$i18n.t('DOWNLOAD_LINKS.P2A') }}
      <strong>{{ this.$i18n.t('DOWNLOAD_LINKS.DREI_NUMBER') }}</strong>
      {{ this.$i18n.t('DOWNLOAD_LINKS.AND') }}
      <strong>{{ this.$i18n.t('DOWNLOAD_LINKS.PASSWORD') }}</strong>
      {{ this.$i18n.t('DOWNLOAD_LINKS.P2B') }}
      <a
        href="https://www.drei.at/de/privat/produkte-und-services/drei-tv/drei-tv-hilfe.html"
        target="_blank"
      >
        {{ this.$i18n.t('DOWNLOAD_LINKS.HELP_SITE') }}
      </a>
    </p>
    <div class="img-container">
      <a
        href="https://apps.apple.com/at/app/3tv/id1159362898"
        target="_blank"
      >
        <img
          class="img-tiny"
          src="@/assets/image/app-download-apple.svg"
        >
      </a>
    </div>
    <div class="img-container">
      <a
        href="https://play.google.com/store/apps/details?id=com.drei.tv&hl=de"
        target="_blank"
      >
        <img
          class="img-tiny"
          src="@/assets/image/app-download-google.svg"
        >
      </a>
    </div>
    <div class="img-container">
      <a
        href="https://www.amazon.de/3TV/dp/B01MXJHKRJ/"
        target="_blank"
      >
        <img
          class="img-tiny"
          src="@/assets/image/app-download-amazon.svg"
        >
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DownloadLinks',
  components: {},
  data: function() {
    return {
      
    };
  },
}
</script>

<style lang="scss" src="@/components/img.scss">
</style>

